import Error from './Error';
import NotFound from './NotFound';

export { Error, NotFound };
export default { Error, NotFound };
